import { createContext, useContext } from "react";
import { ISelectedEditInput } from "components/draggableEditInput/DraggableEditInput";
import {
  IUnsavedChangesContainer,
  IUnsavedChangesDispatchActions,
} from "hooks/useUnsavedChangesContainer/useUnsavedChangesContainer";
import { TStatusInputRows } from "./StatusInputs";

export type StatusInputHandleUpdateInput = (
  id: any,
  label: string,
  helpText: string,
  value: string[] | null,
  isRequired?: boolean,
) => void;

interface IStatusInputContext {
  selectedInput: ISelectedEditInput;
  setSelectedInput: React.Dispatch<React.SetStateAction<ISelectedEditInput>>;
  inputRowsContainer: IUnsavedChangesContainer<TStatusInputRows>;
  inputRowsContainerActions: IUnsavedChangesDispatchActions<TStatusInputRows>;
  handleUpdateInput: StatusInputHandleUpdateInput;
  closeInputEditModal: () => void;
}

const defaultStatusInputContext: IStatusInputContext = {
  selectedInput: undefined,
  setSelectedInput: undefined,
  inputRowsContainer: undefined,
  inputRowsContainerActions: undefined,
  handleUpdateInput: undefined,
  closeInputEditModal: undefined,
};

export const StatusInputContext = createContext<IStatusInputContext>(defaultStatusInputContext);
export const useStatusInputContext = () => useContext(StatusInputContext);
